interface ModalOptions {
    title: string;
    text: string;
    icon: string;
    id: string;
    buttons: string;
}

export class DynamicModal {
    static async CreateModalDialog() {
        const id = "dialogModal"
        // Dynamicly add modal if not already present
        if (document.getElementById(id) === null) {
            await this.createModal({
                title: "title",
                text: "text",
                icon: "fa fa-exclamation-triangle",
                id: id,
                buttons: this.createButtonHTML("btn btn-danger", "luscinia-confirm-dialogbutton", "Yes", "true") +
                         this.createButtonHTML("btn btn-primary", "luscinia-confirm-dialogbutton", "No", "false")
            });
        } else {
            console.warn("There already exists a #%s on this page. This is no longer necessary, try to remove the modal.", id);
        }
    }

    static async CreateModalWarning() {
        const id = "warningDialogModal"
        if (document.getElementById(id) === null) {
            await this.createModal({
                title: "title",
                text: "text",
                icon: "fa fa-exclamation-triangle",
                id: id,
                buttons: ""
            });
        } else {
            console.warn("There already exists a #%s on this page. This is no longer necessary, try to remove the modal.", id);
        }
    }

    static async CreateModalConfirm(id : string) {
        
        if (document.getElementById(id) === null) {
            await this.createModal({
                title: "title",
                text: "text",
                icon: "fa fa-exclamation-triangle",
                id: id,
                buttons: this.createButtonHTML("btn btn-danger", "luscinia-confirm-dialogbutton", "Yes", "true")
            });
        } else {
            console.warn("There already exists a #%s on this page. This is no longer necessary, try to remove the modal.", id);
        }
    }


    static createModal(modal: ModalOptions): Promise<void> {
        return new Promise((resolve) => {
            const modalHTML = `
                <div class="modal fade" id="${modal.id}" tabindex="-1" role="dialog" data-keyboard="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header border-0">
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body py-0">
                                <div class="text-center">
                                    <div class="text-danger"><i class="${modal.icon} fs-1 py-3"></i></div>
                                    <h4><span id="dialogModalTitle">${modal.title}</span></h4>
                                    <p id="dialogModalText">${modal.text}</p>
                                </div>
                            </div>
                            <div class="modal-footer border-0">
                                ${modal.buttons}
                            </div>
                        </div>
                    </div>
                </div>
            `;
            document.body.insertAdjacentHTML('beforeend', modalHTML);
            resolve();
        });
    }

    static remove() {
        // wait for bootstrap animation before remove
        setTimeout(() => {
            document.getElementById('dialogModal').remove();
        }, 500);
    }
    

    private static createButtonHTML(style: string, type: string, text: string, bool: string) : string {
        return `<button type="button" class="${style} ${type}" data-luscinia-value="${bool}" data-bs-dismiss="modal">${text}</button>`
    }
}